// extracted by mini-css-extract-plugin
export default {"history":"History_history__TNCsY","header":"History_header__FV2PS","deals":"History_deals__oR-Ci"};